<fc-search-input
  [label]="label || 'PRODUCT.LABEL' | translate"
  [control]="control"
  [isLocationInput]="true"
  [search]="search"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [translateErrorPrefix]="translateErrorPrefix"
  [enableInfiniteScroll]="true"
></fc-search-input>
